export const FEATURE_FLAG_MATCHING = "retailers.pim.show-matching-verification";
export const FEATURE_FLAG_MARKDOWN_CADENCE = "markdown_cadence";
export const FEATURE_FLAG_ERROR_REPORT = "retailers.verifications.error-report";
export const FEATURE_FLAG_VERIFICATION_V2 = "retailers.verifications.ui-v2";
export const FEATURE_FLAG_AI_DESCRIPTION_REWORK = "ai_description_rework";
export const FEATURE_FLAG_AUTOMATIC_AI_DESCRIPTION = "verifications.automatic_ai_description";
export const FEATURE_FLAG_VERIFICATION_V2_AUTOFILL = "retailers.verifications.v2-autofill";
export const FEATURE_FLAG_AI_VERIFICATION_V2_AUTOFILL = "retailers.ai-verifications.v2-autofill";
export const FEATURE_FLAT_SEARCH_V2 = "retailers.search.v2";
export const FEATURE_FLAG_VACATION_MODE = "retailers.vacation-mode";
export const FEATURE_FLAG_TRANSACTION_REPORTS = "retailers.reports";
export const FEATURE_FLAG_PRICE_DROPS_ENHANCEMENTS = "retailers.pricing.price_drops_enhancements";
export const FEATURE_FLAG_AI_VERIFICATION_AB_ENABLED = "retailers.ai-verifications.ab-enabled";
export const FEATURE_FLAG_LIGHTSPEED_SOURCE_AI_ENABLED = "retailers.ai-verifications.lightspeed-enabled";
export const FEATURE_FLAG_GENERIC_CSV_SOURCE_AI_ENABLED = "retailers.ai-verifications.generic-csv-enabled";
export const FEATURE_FLAG_SHOPIFY_SOURCE_AI_ENABLED = "retailers.ai-verifications.shopify-enabled";
export const FEATURE_FLAG_SDA_AI_FILTER = "retailers.ai-verifications.filter-search-enhanced";
export const FEATURE_FLAG_FLAG_A_LISTING = "retailers.flag-a-listing";
export const FEATURE_FLAG_VALIDATE_PAYMENT_INTENT = "retailers.cart-confirm.validate-payment-intent";
export const FEATURE_FLAG_TYPESENSE_MATCHING = "retailers.verifications.typesense-matching";
